<template>
  <div class="w-table w-table--wrap">
    <div class="w-table__scroll-wrap">
      <table class="w-table" color="light">
         <thead>
          <tr>
             <th class="w-table__header  text-center" width="1%">BIL</th>
              <th class="w-table__header  text-center">ID | NAMA ANAK</th>
              <th class="w-table__header  text-center">REMARK</th>
              <th class="w-table__header  text-center">TARIKH LAHIR</th>
              <th class="w-table__header  text-center">GENERASI ANAK</th>
              <th class="w-table__header  text-center">BAKA ANAK</th>
              <th class="w-table__header  text-center">TINDAKAN</th>      
          </tr>
        </thead>

        <tbody>
          <tr v-for="(dt, ind) in datas" :key="dt.audit_id + '-' + dt.anak_ke">
            <td class="text-center">{{ ind + 1 }}</td>

            <td class="text-center">
             {{ dt.anak_id }} | {{ dt.anak_nama }}
            </td>

            <td class="text-center">
              Anak Ke-{{ dt.anak_ke }}
            </td>

            <td class="text-center">
              {{ $zutil.dateformat(dt.data.tarikh_lahir) ?? '-' }}
            </td>

            <td class="text-center">
              {{ dt.gred }}
            </td>

            <td class="text-center">
              {{ dt.baka }}
            </td>

            <td class="text-center">
              <w-button
                dark
                class="info-dark1--bg"
                @click="papar(dt)"
              >
                <w-icon class="mr1">fal fa-eye</w-icon>
                PAPAR
              </w-button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>


    <w-dialog
    v-model="dialog_papar.show"
    :fullscreen="dialog_papar.fullscreen"
    :width="dialog_papar.width"
    :persistent="dialog_papar.persistent"
    :persistent-no-animation="dialog_papar.persistentNoAnimation"
    title-class="primary-dark1--bg white"
  >
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Jejak ART Anak Ke-{{ selectedAuditDetail.anak_ke }}
    </template>

  <div class="audit-dialog-content">
    <div class="w-table-wrap">
      <table class="w-table" color="light">
        <thead>
          <tr>
            <th class="w-table__header text-center">STATUS KELAHIRAN</th>
            <th class="w-table__header text-center">TARIKH LAHIR</th>
            <th class="w-table__header text-center">NAMA</th>
            <th class="w-table__header text-center">JANTINA</th>
            <th class="w-table__header text-center">KAEDAH KELAHIRAN</th>
            <th class="w-table__header text-center">BERAT LAHIR (KG)</th>
            <th class="w-table__header text-center">WARNA BULU</th>
            <th class="w-table__header text-center">CACAT</th>
          </tr>
        </thead>

        <tbody v-if="selectedAuditDetail">
          <tr>
            <td class="text-center">
              {{ selectedAuditDetail.status ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.tarikh_lahir ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.anak_nama ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.jantina ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.kaedah_kelahiran ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.berat_lahir ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.warna ?? '-' }}
            </td>

            <td class="text-center">
              {{ selectedAuditDetail.cacat ?? '-' }}
            </td>
          </tr>
        </tbody>



      </table>
    </div>
  </div>

    <template #actions>
      <div class="spacer"></div>
      <w-button
        style="background-color:#f0f0f0;border:2px solid red;color:#333;font-size:11px;"
        @click="dialog_papar.show = false"
      >
        TUTUP
      </w-button>
    </template>
  </w-dialog>
</div>
</template>


<script>
export default {
  name: "AuditArt",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [], 
      selectedAuditDetail: {}, 
      dialog_papar: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1200,
      },
    }
  },
  methods:{
    getData(){
      this.$zcomm
        .get(this.api_service + 'ternakan/audit_ternakan_anak/' + this.data.id, {})
        .then(res => {
          this.datas = res
        })
    },

    papar(dt){
      this.selectedAuditDetail = dt;
      this.dialog_papar.show = true;
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
/* Tambahkan sedikit gaya untuk menjadikan label lebih menonjol */
.font-weight-bold {
  font-weight: bold;
}
/* Spasi dalam body dialog */
.audit-dialog-content {
  padding: 20px 24px;
}

/* Spasi table */
.audit-dialog-content .w-table {
  margin-top: 10px;
}

/* Spasi antara baris */
.audit-dialog-content td,
.audit-dialog-content th {
  padding: 10px 8px;
}

/* Tinggi baris lebih selesa */
.audit-dialog-content tr {
  line-height: 1.6;
}



</style>